import React, { useEffect } from 'react';
import { AuthProvider } from '@/libs/device-auth';
import { AppContent } from './AppContent';
import { ThemeProvider } from '@oolio-group/design-ui-react';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import './global.css';

export const App: React.FC = () => {
  useEffect(() => {
    const initApp = async () => {
      if (Capacitor.isNativePlatform()) {
        await StatusBar.hide();
        await StatusBar.setStyle({ style: Style.Default });
        SplashScreen.hide();
      }
    };

    initApp();
  }, []);

  return (
    <ThemeProvider auto={false}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
};
